import { useCallback, useState } from "react";

import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryState,
} from "nuqs";

import { CertificationParticipantsControls } from "@/components/pages_logged_in/certifications/CertificationParticipantsControls";
import { CertificationParticipantsTable } from "@/components/pages_logged_in/certifications/CertificationParticipantsTable";
import { Group } from "@/components/pages_logged_in/certifications/GroupFilter";
import { Pagination } from "@/components/pages_logged_in/certifications/Pagination";

const size = 5;

export function CertificationParticipants({
  availableGroups,
  onIssueManually,
  onRevoke,
  workspaceId,
}: {
  availableGroups: Group[];
  onIssueManually: (
    userIds: string[],
    sendNotifications: boolean,
    onClose: (error?: string) => void,
    note?: string,
  ) => void;
  onRevoke: (certificateId: string) => void;
  workspaceId?: string;
}) {
  const [selectedGroupIds, setSelectedGroupIds] = useQueryState(
    "groupIds",
    parseAsArrayOf(parseAsString).withDefault(["all"]),
  );

  const [sort, setSort] = useQueryState("sort", parseAsString);

  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [search, setSearch] = useQueryState(
    "search",
    parseAsString.withDefault(""),
  );
  const [total, setTotal] = useState(0);

  const handleSearchChange = useCallback(
    (search: string) => {
      setSearch(search);
      setPage(1);
    },
    [setSearch, setPage],
  );

  return (
    <div className="flex flex-col gap-4">
      <CertificationParticipantsControls
        search={search}
        onSearchChange={handleSearchChange}
        searching={false}
        availableGroups={availableGroups}
        selectedGroupIds={selectedGroupIds}
        onSelectedGroupIdsChange={setSelectedGroupIds}
        onIssueManually={onIssueManually}
        workspaceId={workspaceId}
      />
      <CertificationParticipantsTable
        search={search}
        selectedGroupIds={selectedGroupIds}
        page={page}
        pageSize={size}
        sort={sort}
        onSortChange={setSort}
        onRevoke={onRevoke}
        onTotalChange={setTotal}
      />
      <Pagination
        total={total}
        page={page}
        size={size}
        onPageChange={setPage}
        pageLoading={false}
      />
    </div>
  );
}
